import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { AiChangeType } from '../../../../../ai';
import { SectionStatus } from '../../domain';
export var AI_ACCEPT_SECTION_CHANGE_USE_CASE = 'AI_ACCEPT_SECTION_CHANGE_USE_CASE';
/**
 * Orchestrator use case for accepting an AI section change.
 * - Add: saves the new section (SaveSectionUseCase → create).
 * - Update: saves the updated section (SaveSectionUseCase → update).
 * - Delete: deletes the section (DeleteSectionUseCase).
 */

export var AiAcceptSectionChangeUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(AiAcceptSectionChangeUseCase, _UseCase);

  var _super = _createSuper(AiAcceptSectionChangeUseCase);

  function AiAcceptSectionChangeUseCase(saveSectionUseCase, deleteSectionUseCase) {
    var _this;

    _classCallCheck(this, AiAcceptSectionChangeUseCase);

    _this = _super.call(this);
    _this.saveSectionUseCase = saveSectionUseCase;
    _this.deleteSectionUseCase = deleteSectionUseCase;
    return _this;
  }

  _createClass(AiAcceptSectionChangeUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var changeType, section, sectionId, saveResult, _saveResult, deleteResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                changeType = input.changeType, section = input.section;
                sectionId = section.id.toString();
                _context.t0 = changeType;
                _context.next = _context.t0 === AiChangeType.Add ? 5 : _context.t0 === AiChangeType.Update ? 12 : _context.t0 === AiChangeType.Delete ? 19 : 25;
                break;

              case 5:
                section.updateStatus(SectionStatus.New);
                _context.next = 8;
                return this.saveSectionUseCase.execute({
                  section: section,
                  formId: section.formId
                });

              case 8:
                saveResult = _context.sent;

                if (!saveResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", mappingResultError(saveResult));

              case 11:
                return _context.abrupt("break", 26);

              case 12:
                section.updateStatus(SectionStatus.Activate);
                _context.next = 15;
                return this.saveSectionUseCase.execute({
                  section: section,
                  formId: section.formId
                });

              case 15:
                _saveResult = _context.sent;

                if (!_saveResult.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", mappingResultError(_saveResult));

              case 18:
                return _context.abrupt("break", 26);

              case 19:
                _context.next = 21;
                return this.deleteSectionUseCase.execute({
                  formId: section.formId,
                  sectionId: sectionId,
                  status: section.status
                });

              case 21:
                deleteResult = _context.sent;

                if (!deleteResult.isFailure) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", mappingResultError(deleteResult));

              case 24:
                return _context.abrupt("break", 26);

              case 25:
                return _context.abrupt("break", 26);

              case 26:
                return _context.abrupt("return", Result.ok({
                  sectionId: sectionId
                }));

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return AiAcceptSectionChangeUseCase;
}(UseCase);